var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditorWhite = function SvgEditorWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-stroke",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon feather-edit-2",
    d: "M24.062 12.742a2.263 2.263 0 1 1 3.2 3.2L16.473 26.723l-4.393 1.2 1.2-4.4Z",
    fill: "none"
  })));
};
export default SvgEditorWhite;